import { SearchableField, isRangeSearchableField } from './ISearchableField';

export function getSearchableFieldNames(field: SearchableField): string[] {
  if (isRangeSearchableField(field)) {
    return [field.from.name, field.to.name];
  }
  return [field.name];
}
